import CardRender from "../components/CardRender"

const routes = [
    {
        path: '/render/',
        component: <CardRender />,
        exact: true,
    }
]
export default routes